var normalizeComponent = require("!../../node_modules/vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader?{\"presets\":[[\"/home/travis/build/fabrikaodua/frontend-ui-modus-8/node_modules/babel-preset-env/lib/index.js\",{\"debug\":false,\"loose\":false,\"modules\":false,\"useBuiltIns\":true,\"include\":[],\"exclude\":[],\"targets\":{\"browsers\":[\"last 3 versions\"]}}]],\"plugins\":[\"/home/travis/build/fabrikaodua/frontend-ui-modus-8/node_modules/babel-plugin-syntax-dynamic-import/lib/index.js\",\"/home/travis/build/fabrikaodua/frontend-ui-modus-8/node_modules/babel-plugin-transform-object-rest-spread/lib/index.js\",\"/home/travis/build/fabrikaodua/frontend-ui-modus-8/node_modules/babel-plugin-transform-class-properties/lib/index.js\"]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!../../node_modules/extract-loader/lib/extractLoader.js!../../node_modules/html-loader/index.js??ref--13-2!./blogpost.vue"
/* template */
import __vue_template__ from "!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4c1aece8\",\"hasScoped\":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!../../node_modules/extract-loader/lib/extractLoader.js!../../node_modules/html-loader/index.js??ref--13-2!./blogpost.vue"
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/blogpost.vue
// module id = ./src/pages/blogpost.vue
// module chunks = index